import axios from "../api";

export const PaylistTransactionDataAction = async (
  perPage,
  page,
  status,
  pId,
  startDate,
  endDate,
  search
) => {
  let apiUrl = `/api/paytransaction/paycentraltransaction?page=${page}&pageSize=${perPage}`;

  if (status && status !== "all") {
    apiUrl += `&status=${status}`;
  }

  if (pId && pId !== "all") {
    apiUrl += `&pId=${pId}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (search) {
    apiUrl += `&search=${search}`;
  }

  return axios.get(apiUrl);
};

export const exportTransactionPaycentralHistoryAction = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/paytransaction/exportpaycentral";
    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const listAllCommonTenants = async (
  currentPage,
  searchValue,
  pageSize,
  status
) => {
  let apiUrl = `/api/paytransaction/listAllCommonTenants?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}`;

  if (status) {
    apiUrl += `&status=${status}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => resolve(response?.data))
      .catch((error) => reject(error));
  });
};


